package Utils

import kotlinx.serialization.json.Json
import printPlat
import kotlin.math.abs
import kotlin.math.max
import kotlin.math.roundToInt
import kotlin.math.roundToLong

val myMail = "nihulkav@gmail.com"
var RESOURCES_FOLDER = "./resources/"
val MAX_LARGE_VALUE = 1000000
var userInput: Map<String, String> = emptyMap()
val months_to_number: Map<String, Int> = mapOf(
        "ינואר" to 1, "פברואר" to 2, "מרץ" to 3, "אפריל" to 4, "מאי" to 5, "יוני" to 6, "יולי" to 7, "אוגוסט" to 8,
        "ספטמבר" to 9,
        "אוקטובר" to 10, "נובמבר" to 11, "דצמבר" to 12
)

fun prepareStrToJson(str: String,map: Map<Char, String>?=null): String {

    return str.replace(
        map?: mapOf(
            '\n' to "",
            '\"' to "",
            '\'' to "",
            '\r' to "",
            '\\' to "",
            '?' to "",
            '%' to ""
        )
    ).trim()

}

fun smartSearch(str: String, full: String): Boolean {
    var i = 0
    str.forEachIndexed { index, s ->
        while (i < full.length && s != full[i])
            i += 1
        if (i == full.length)
            return false
        i += 1
    }
    return true
}

fun subStringMatch(str: String, full: String): Boolean {
    val splitSearch = str.split(" ")
    val splitFull = full.split(" ")
    splitSearch.forEachIndexed { index, s ->
        if (!splitFull.any { it.contains(s) })
            return false

    }
    return true
}
fun timeLock(hourLock:String): Boolean {
    val dt = DatesManipulator.dateNow()
    val time = DatesManipulator.getTime(dt).split(":")
    val hour = time[0].toInt()
    val min = time[1].toInt()
    val hours = hourLock.split(":")
    val lockHour = hours[0].toIntOrNull() ?:0
    val lockMin = if(hours.size==2) hours[1].toIntOrNull() ?:0 else 0
    val lock_time = (lockHour>0 || lockMin>0) && (lockHour<hour || (lockHour==hour && lockMin<min))
    return lock_time
}


val number_to_month: Map<Int, String> = mapOf(
        1 to "ינואר", 2 to "פברואר", 3 to "מרץ", 4 to "אפריל", 5 to "מאי", 6 to "יוני", 7 to "יולי", 8 to "אוגוסט",
        9 to "ספטמבר",
        10 to "אוקטובר", 11 to "נובמבר", 12 to "דצמבר"
)
val Banks: Map<String, Int> = mapOf(
        "בנק אגוד לישראל" to 13,
        "בנק דיסקונט" to 11,
        "בנק הפועלים" to 12,
        "בנק יהב" to 4,
        "בנק ירושלים" to 54,
        "בנק לאומי" to 10,
        "בנק מזרחי" to 20,
        "הבנק הבינלאומי" to 31,
        "בנק מרכנתיל" to 17,
        "בנק אוצר החייל" to 14,
        "בנק הדואר" to 9,
        "וואן זירו" to 18,
    "פאגי בנק פועלי אגודת ישראל" to 52,
    "בנק פועלי אגודת ישראל" to 52,
    "בנק פלסטין" to 38,
    "בנק סיטי" to 22,
        "בחר בנק" to -1
)
val InverseBanks: Map<Int, String> = mapOf(
        13 to "בנק אגוד לישראל",
        11 to "בנק דיסקונט",
        12 to "בנק הפועלים",
        4 to "בנק יהב",
        54 to "בנק ירושלים",
        10 to "בנק לאומי",
        20 to "בנק מזרחי",
        31 to "הבנק הבינלאומי",
        17 to "בנק מרכנתיל",
        14 to "בנק אוצר החייל",
        9 to "בנק הדואר",
        18 to "וואן זירו",
        52 to "פאגי בנק פועלי אגודת ישראל",
        38 to "בנק פלסטין",
    22 to "בנק סיטי",
        -1 to "בחר בנק"
)
val banks = Banks.entries.toList().map { "${it.key}-${it.value}" }.sortedBy { it }
val baseOrderDaysToData: Map<Int, String> = mapOf(
        0 to "2010-01-03",
        1 to "2010-01-04",
        2 to "2010-01-05",
        3 to "2010-01-06",
        4 to "2010-01-07",
        5 to "2010-01-08",
        6 to "2010-01-09",

        )
val hebrewDayToInt: Map<String, Int> = mapOf(
        "א" to 1,
        "ב" to 2,
        "ג" to 3,
        "ד" to 4,
        "ה" to 5,
        "ו" to 6,
        )
val inverseBaseOrderDaysToData: Map<String, String> = mapOf(
        "2010-01-03" to "בסיס א",
        "2010-01-04" to "בסיס א",
        "2010-01-05" to "בסיס ב",
        "2010-01-06" to "בסיס ג",
        "2010-01-07" to "בסיס ד",
        "2010-01-08" to "בסיס ה",
        "2010-01-09" to "בסיס ו",
)
val unclosed_date = "2011-01-01"

fun getopt(args: Array<String>): Map<String, String> {
    var last = ""

    return args.fold(mutableMapOf()) { acc: MutableMap<String, String>, s: String ->
        acc.apply {
            if (s.startsWith("--")) {
                var key = s.let { it.slice(IntRange(2, it.length - 1)) }
                last = key
            } else if (s.startsWith("-")) {
                var key = s.let { it.slice(IntRange(1, it.length - 1)) }
                this[key] = ""
            } else this[last] = s
        }
    }
}

fun roundToDecimals(f: Float, decimals: Int): Float {
    var dotAt = 1
    repeat(decimals) { dotAt *= 10 }
    val roundedValue = (f * dotAt).roundToLong()
    return (roundedValue / dotAt) + (roundedValue % dotAt).toFloat() / dotAt
}

fun prettyRoundString(f: Float, decimals: Int): String {
    val new_f = roundToDecimals(f, decimals)
    val int = new_f.toInt()
    if (int.toFloat() == new_f)
        return int.toString()
    return new_f.toString()
}

fun splitNameToEqSize(name: String, size: Int = 2): List<Int> {
    val slices = mutableListOf<Int>()
    splitNameToEqSizeWrapper(name, size, slices)
    return slices
}

fun splitNameToEqSizeWrapper(name: String, size: Int = 2, res: MutableList<Int>) {
    val length = name.length
    val mid: Int = length / size
    var upperInd: Int = mid
    var lowerInd: Int = mid

    while (upperInd < length && name[upperInd] != ' ')
        upperInd += 1
    while (lowerInd >= 0 && name[lowerInd] != ' ')
        lowerInd -= 1
    val worstUpperSize: Int = max(length - upperInd, upperInd)
    val worstLowerSize: Int = max(lowerInd, length - lowerInd)
    if (worstUpperSize > worstLowerSize) {
        res.add(lowerInd)
    } else
        res.add(upperInd)
    if (size == 2) {
        return
    } else {
        splitNameToEqSizeWrapper(name.substring(res.last()), size - 1, res)
    }

}


fun <K, V> MutableMap<K, V>.putIfAbsent(key: K, value: V) {
    if (!containsKey(key)) {
        this[key] = value
    }
}

fun getJsonWithConfig(): Json {
    return Json {
        allowStructuredMapKeys = true
        coerceInputValues = true;
        allowSpecialFloatingPointValues = true; encodeDefaults = false; isLenient = true;ignoreUnknownKeys = true
    }
}

fun fixJsonInternal(s: String): String {

    return (s).map {
        when (it) {
            '\"' -> {
                '\''
            }
//            '\\' -> {
//                ""
//            }
            else -> {
                it
            }
        }

    }.joinToString("")

}

fun fixJson(s: String): String {

    return (s).map {
        when (it) {
            '\'' -> {
                '\"'
            }

            '\"' -> {
                '\''
            }
//            '\\' -> {
//                ""
//            }
            else -> {
                it
            }
        }

    }.joinToString("")

}

fun Boolean.toInt(): Int {
    return if (this)
        1
    else 0
}

fun String?.isNotEmpty(cond: Boolean = true, default: String): String {
    if (!this.isNullOrEmpty() && cond)
        return this
    return default
}

fun String.replace(map: Map<Char, String>): String {
    return this.map { map[it] ?: it.toString() }.joinToString("").trim()
}

val regularStrClean = mapOf('\n' to "", '\"' to "")
val regularFullStrClean = mapOf('\n' to "", '\"' to "", '\r' to "", '\t' to "", "\'" to "")
fun String.cut(size: Int, end: Boolean = false): String {
    if (this.length < size)
        return this

    return if (end) this.takeLast(size) else this.take(size)
}

fun Float.isZero(): Boolean {
    return this == 0f
}
fun Float.roundZeroSmall(th:Float=0.1f): Float {
    return if(abs(this) <= th) 0f else this
}
fun Float?.isNullOrZero(): Boolean {
    return this == null || this == 0f
}

val badPhoto =
        "data:image/jpeg;base64,eyJzdGF0dXMiOiJFUlJPUiIsInN0YXR1c19tc2ciOiJJbnRlcm5hbCBFcnJvciJ9Cg==".encodeToByteArray()
val noImgPhoto =
        "data:image/png;base64,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".encodeToByteArray()


enum class ReportType {
    DATA_TO_ACCOUNTANT,
    DATA_TO_RECIPT,
    DATA_TO_INVOICES,
    DATA_TO_GAIN,
    DATA_TO_GAIN_SUP,
    DATA_TO_OPEN_CARTESET,
    DATA_TO_DEBTS,
    DATA_TO_KUPA,
    DATA_TO_GIUL,
    DATA_TO_HAFKADA

}
